import { useEffect } from "react";

/**
 * Adds a useEffect hook that updates the title, and reverts
 * to the original on cleanup.
 *
 * @param {string} title
 */
export function useDocumentTitle(title: string | null) {
  useEffect(() => {
    const oldTitle = document.title;

    if (title) document.title = title;

    return () => {
      document.title = oldTitle;
    };
  }, [title]);
}

export const TITLE_SEP = "\u2013";
export const TITLE_POSTFIX = `${TITLE_SEP} NAF Digital skademelding`;
